import { Stack } from "@mui/material"
import { ReactElement, useContext } from "react"

import CreateHpDeviceProgressStepper from "./components/createHpDeviceProgressStepper"
import CoreHpDeviceDetails from "./formPages/coreHpDeviceDetails"
import HpManufacturer from "./formPages/hpManufacturer"
import ReviewAndSubmitHpDevice from "./formPages/reviewAndSubmitHpDevice"
import { CreateHpDeviceContext } from "./providers/baseProviders/createHpDeviceProvider"
import { Datasets } from "../../../../constants/enums"
import { GRID_SPACING } from "../../../../themes/defaultThemeParams"
import MultiPageForm from "../../../multiPageForm/multiPageForm"
import { AppCard, AppCardContent } from "../../../surfaces/appCard"
import LctDeviceAttachments from "../../common/components/attachments/lctDeviceAttachments"
import { HpDeviceFormData } from "../types/providerTypes"

/** The form for creating an Hp device */
const CreateHpDeviceForm = (): ReactElement => {
    const { canEditManufacturer } = useContext(CreateHpDeviceContext)

    return (
        <Stack spacing={GRID_SPACING}>
            <AppCard>
                <AppCardContent>
                    <CreateHpDeviceProgressStepper />
                </AppCardContent>
            </AppCard>
            <MultiPageForm context={CreateHpDeviceContext}>
                {canEditManufacturer && (
                    <HpManufacturer context={CreateHpDeviceContext} />
                )}
                <CoreHpDeviceDetails context={CreateHpDeviceContext} />
                <LctDeviceAttachments<HpDeviceFormData>
                    context={CreateHpDeviceContext}
                    dataset={Datasets.HP}
                    isAmendment={false}
                />
                <ReviewAndSubmitHpDevice
                    context={CreateHpDeviceContext}
                    isAmendment={false}
                />
            </MultiPageForm>
        </Stack>
    )
}

export default CreateHpDeviceForm
